import { render, staticRenderFns } from "./CartLine.vue?vue&type=template&id=20345924&"
import script from "./CartLine.vue?vue&type=script&lang=ts&"
export * from "./CartLine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductDiscountLabels: require('/app/components/product/DiscountLabels.vue').default,BaseInputNumber: require('/app/components/base/InputNumber.vue').default,BaseButton: require('/app/components/base/Button.vue').default})
